export * from './ecall-create.component';
export * from './ecall-create.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-create/index.ts